<mat-card *ngIf="blockData && !isServerError">
  <mat-card-content>
    <app-alert *ngIf="(!blockData.averages || blockData.averages.length == 0) && blockData.noGradesExistsMessage"
      class="mb-1" 
      [icon]="'alert'"
      >{{blockData.noGradesExistsMessage}}
    </app-alert>

    <app-my-grades [averages]="blockData.averages" [noGradesMessage]="blockData.noGradesExistsMessage"></app-my-grades>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="isServerError">
  <app-timeout-error-message></app-timeout-error-message>
</mat-card>